import React from 'react';
import spinner from '../../ASUPhotos/spinner.svg';

function Loading(props) {
  return (
    <div className="spinner-container" style={{ height: props.height }}>
      <img src={spinner} className="loading-spinner" alt="Loading..." />
    </div>
  );
}

export default Loading;
